import { useSelector as reduxUseSelector } from 'react-redux';

import type { RootState } from '@/redux/rootReducer';

export const useSelector = reduxUseSelector.withTypes<RootState>();
